/**
 * @title:
 * @fileName: IndexUrl
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/6/14 13:46
 * @modified By：
 * @version:     1.0$
 * @description: TODO
 */

class IndexUrl {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
        this._hostname = hostname
        this._path = path
    }

    get ownership (){
        return this._api + '/authority/getprovincialorgan'
    }
    get contact (){
        return this._api + '/authority/gerorganuserlist'
    }
}
export default IndexUrl
